import { useEffect, useState } from 'react'
import { apiRead, usePermissions } from '../admin/primitives.js'
import type { Tableau } from './interphone-model.js'

/**
 * INTERPHONE IA — LE COMPTE RÉEL DE LA TUILE DU HUB SÉCURITÉ (22/10/2026).
 *
 * Doctrine « tuile = navigation » : UN compte (les appels du jour, lus chez le
 * service Interphone à l'ouverture du hub), rien d'autre — ni table, ni
 * action, rien de stocké. Sans le droit de lecture, aucun appel ne part ; une
 * lecture refusée ou en panne se dit, sans chiffre inventé.
 */
export function SyntheseInterphone() {
  const { permissions, loading } = usePermissions()
  const peutLire = !loading && permissions.includes('interphone.read')
  const [n, setN] = useState<number | null>(null)
  const [erreur, setErreur] = useState<false | 'panne' | 'non_raccorde'>(false)

  useEffect(() => {
    if (!peutLire) return
    let vivant = true
    void apiRead<Tableau>('/api/v1/interphone/tableau')
      .then((r) => {
        if (!vivant) return
        if (r.status === 200 && typeof r.data?.aujourdhui?.appels === 'number') setN(r.data.aujourdhui.appels)
        else setErreur((r.data as { error?: unknown } | null)?.error === 'INTERPHONE_NOT_CONFIGURED' ? 'non_raccorde' : 'panne')
      })
      .catch(() => { if (vivant) setErreur('panne') })
    return () => { vivant = false }
  }, [peutLire])

  if (!peutLire) return null
  if (erreur) return <span className="fh-tile__synthese fh-tile__synthese--muette">{erreur === 'non_raccorde' ? 'Non raccordé' : 'Compte indisponible'}</span>
  if (n === null) return <span className="fh-tile__synthese" aria-busy="true">…</span>
  return (
    <span className="fh-tile__synthese">
      <strong className="fh-tile__compte">{n === 0 ? 'Aucun appel' : `${n} appel${n > 1 ? 's' : ''}`}</strong>
      <span className="fh-tile__detail">aujourd’hui</span>
    </span>
  )
}
